<template>
  <div class="wxtips" @touchmove.prevent @mousewheel.prevent>
    <i class="bg"></i>
    <div class="tipscontent">
      <p class="title">{{title}}</p>
      <div id="qrcode"  ref="qrcode"></div>
      <div class="close" @click="close()">确认</div>
    </div>
  </div>
</template>

<script>
  import {mapState,mapMutations} from "vuex"
  import QRCode from "qrcodejs2-fix"
  export default {
    components:{
      QRCode
    },
    data(){
      return{
        info:JSON.parse(sessionStorage.getItem('info')),
        title:"请使用手机微信客户端扫码",
        link:''
      }
    },
    created(){
      this.link="https://"+this.info.urlkey+"."+JSON.parse(sessionStorage.getItem('site')).mobiledomin +"/login?id="+this.info.id;
    },
    methods:{
      ...mapMutations('showData',['changeTFalse']),
      // 生成二维码
      creatQrCode() {
        new QRCode('qrcode', {
          text:this.link, //二维码地址，避免识别不了url地址将进行编码
          width: 200, //单位（px）
          height: 200, //单位（px）
          colorDark: "#000000", //二维码颜色：支持英文、十六进制、RGB、RGBA
          colorLight: "#FFFFFF", //二维码背景色：支持英文、十六进制、RGB、RGBA
          render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          correctLevel: QRCode.CorrectLevel.L, //容错率，由低到高：L/M/Q/H
        })
      },
      close(){
        this.changeTFalse([{name:'wxtipsShow',value:false}])
      }
    },
    mounted(){
      this.creatQrCode()
    },
    computed:{
      ...mapState('showData',['wxtipsShow'])
    }
  }
</script>

<style lang="less" scoped>
div.wxtips{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  display: flex;
  align-items: center;
  justify-content: center;
  .bg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: rgba(0, 0, 0,.5);
    right: 0;
    max-width: 10rem;
    margin:0 auto;
  }
  .tipscontent{
    position: relative;
    z-index: 2;
    width: 8rem;
    background: white;
    border-radius: .2666667rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: .32rem;
    p.title{
      padding: .5333333rem;
      font-size: .32rem;
    }
    div.close{
      padding: .4rem 0;
      color: #ee0a24;
    }
    div#qrcode{
      display: flex;
      justify-content: center;
    }
  }
}
</style>